import { render, staticRenderFns } from "./FinalizarPadrao.vue?vue&type=template&id=33e51fc9"
import script from "./FinalizarPadrao.vue?vue&type=script&lang=js"
export * from "./FinalizarPadrao.vue?vue&type=script&lang=js"
import style0 from "./FinalizarPadrao.vue?vue&type=style&index=0&id=33e51fc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports